import type { ReactNode } from 'react'

/**
 * An empty list says what would fill it and offers the way to (Nov 4 2026, the Coinbase pattern): a short title, one
 * line of context, and the action when the view has one. One grey sentence ("No strategies yet.") said neither.
 * `compact` is for a popover.
 */
export function EmptyState({ title, children, action, compact = false }: { title: string; children?: ReactNode; action?: ReactNode; compact?: boolean }) {
  return (
    <div className={`flex flex-col items-center justify-center text-center ${compact ? 'gap-1 px-4 py-6' : 'gap-1.5 px-6 py-10'}`}>
      <p className="text-sm font-medium">{title}</p>
      {children ? <p className="max-w-xs text-sm text-muted">{children}</p> : null}
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  )
}
